import {Facebook, Instagram, Link2, Twitter, Youtube} from "react-feather";
import {route, trans} from "../../../modulesCompiler";
import {Link, useHistory} from "react-router-dom";
import skyLimit from "../../../../assets/images/sky-limit.png";
import useGetSetting from "../../../settings/widgets/useGetSetting";

function PublicFooter() {
    const history = useHistory();
    const facebook = useGetSetting("facebook");
    const instagram = useGetSetting("instagram");
    const twitter = useGetSetting("twitter");
    const youtube = useGetSetting("youtube");
    const contact = useGetSetting("contact");

    const link1 = useGetSetting("link 1");
    const link2 = useGetSetting("link 2");
    const link3 = useGetSetting("link 3");
    const link4 = useGetSetting("link 4");
    const link5 = useGetSetting("link 5");



    return <footer className="container-fluid text-white pb-4" style={{background: "#c51f2d"}}>
        <div className="pt-5 pb-5 mb-4">
            <div className="row ms-md-5 me-md-5">
                <div className="col-md mb-4 mb-md-0">
                    <h5 className="oswald fw-bold mb-4 text-uppercase">
                        {trans("mreze")}
                    </h5>

                    {instagram.value &&
                    <div className="mb-2">
                        <a href={instagram.value} target="_blank" rel="noreferrer" className="link-light">
                            <Instagram className="me-2" /> Instagram
                        </a>
                    </div>}
                    {twitter.value &&
                    <div className="mb-2">
                        <a href={twitter.value} target="_blank" rel="noreferrer" className="link-light">
                            <Twitter className="me-2" /> Twitter
                        </a>
                    </div>}
                    {facebook.value &&
                    <div className="mb-2">
                        <a href={facebook.value} target="_blank" rel="noreferrer" className="link-light">
                            <Facebook className="me-2" /> Facebook
                        </a>
                    </div>}
                    {youtube.value &&
                    <div className="mb-2">
                        <a href={youtube.value} target="_blank" rel="noreferrer" className="link-light">
                            <Youtube className="me-2" /> Youtube
                        </a>
                    </div>}
                </div>
                <div className="col-md mb-4 mb-md-0">
                    <h5 className="oswald fw-bold mb-4 text-uppercase">
                        {trans("kontakt")}
                    </h5>
                    <div className="prewrap lh-lg link-light"
                         dangerouslySetInnerHTML={{__html: contact.value}} />
                </div>
                <div className="col-md mb-4 mb-md-0">
                    <h5 className="oswald fw-bold mb-4 text-uppercase">
                        {trans("mapa sajta")}
                    </h5>
                    <div className="lh-lg">
                        {[
                            {id: "index", route: route("public.index"), trans: trans("naslovna")},
                            {id: "about" ,route: route("public.about"), trans: trans("o nama")},
                            {id: "shop", route: route("products.shop"), trans: trans("shop")},
                            {id: "blog", route: route("blog.blog"), trans: trans("blog")},
                            {id: "kontakt", route: route("public.contact"), trans: trans("kontakt")},
                        ].map((item, index) => {
                            return  <div key={item.id}>
                                <Link to={item.route}
                                      className={`${history.location.pathname ===item.route  ? "active link-light" : "link-light"}`}>
                                    {item.trans}
                                </Link>
                            </div>
                        })}
                    </div>
                </div>
                <div className="col-md mb-4 mb-md-0">
                    <h5 className="oswald fw-bold mb-4 text-uppercase">
                        {trans("kupovina")}
                    </h5>
                    <div className="lh-lg">
                        {[
                            {id: "faq5", route: route("public.politikaPrivatnosti"), trans: trans("politika privatnosti")},
                            {id: "faq1", route: route("public.usloviKoriscenja"), trans: trans("uslovi koriscenja")},
                            {id: "faq2" ,route: route("public.kakoKupiti"), trans: trans("kako kupiti")},
                            {id: "faq8", route: route("public.politikaKolacica"), trans: trans("politika kolacica")},
                            {id: "faq3", route: route("public.pravoNaOdustajanje"), trans: trans("pravo na odustajanje")},
                            {id: "faq4", route: route("public.usloviIsporuke"), trans: trans("uslovi isporuke")},
                            {id: "faq6", route: route("public.reklamacije"), trans: trans("reklamacije")},
                        ].map((item, index) => {
                            return  <div key={item.id}>
                                <Link to={item.route} className="link-light">{item.trans}</Link>
                            </div>
                        })}
                    </div>
                </div>
                <div className="col-md-3 mb-4 mb-md-0">
                    <h5 className="oswald fw-bold mb-4 text-uppercase">
                        {trans("vazni linkovi")}
                    </h5>
                    <div className="lh-lg mb-4">
                        {link1.value &&
                        <div className="mb-2">
                            <a href={link1.value} target="_blank" rel="noreferrer" className="link-light">
                                <Link2 className="me-1 link-light" /> {link1.value}
                            </a>
                        </div>}
                        {link2.value &&
                        <div className="mb-2">
                            <a href={link2.value} target="_blank" rel="noreferrer" className="link-light">
                                <Link2 className="me-1" /> {link2.value}
                            </a>
                        </div>}
                        {link3.value &&
                        <div className="mb-2">
                            <a href={link3.value} target="_blank" rel="noreferrer" className="link-light">
                                <Link2 className="me-1" /> {link3.value}
                            </a>
                        </div>}
                        {link4.value &&
                        <div className="mb-2">
                            <a href={link4.value} target="_blank" rel="noreferrer" className="link-light">
                                <Link2 className="me-1" /> {link4.value}
                            </a>
                        </div>}
                        {link5.value &&
                        <div className="mb-2">
                            <a href={link5.value} target="_blank" rel="noreferrer" className="link-light">
                                <Link2 className="me-1" /> {link5.value}
                            </a>
                        </div>}
                    </div>

                    <div>
                        <a href='https://www.horus.rs/trust/'>
                            <img src='https://verify.etrustmark.rs/cert/image.php' alt="eTrustmark" className="img-fluid" />
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div className="text-center mb-5 d-flex justify-content-center">
            <div style={{maxWidth: 420}}>
                <img src={skyLimit} className="img-fluid" alt="Sky is the limit." />
            </div>
        </div>
        <div className="container">
            <div className="text-center mb-4 fs-s">
                {trans("footer disclaimer")}
            </div>
        </div>


        <div className="text-center text-white" style={{fontSize: "0.9rem"}}>
            Horus wear d.o.o. {new Date().getFullYear()}. Developed by <a href="https://superweb.rs"
                                         target="_blank" rel="noreferrer" className="superweb">
                SuperWeb
            </a>
        </div>
        <div className="mb-6 d-md-none" />
    </footer>
}
export default PublicFooter;